import { makeContext } from "@shared/utils/makeContext";
import { ChatState, ChatAction } from './chat.types';

// --- Name ---
const NAME = "Chat";

// --- Constants ---
export const OPEN_CHAT = "chat/open" as const;
export const CLOSE_CHAT = "chat/close" as const;
export const TOGGLE_CHAT = "chat/toggle" as const;

export const ACTION_TYPES = {
  OPEN_CHAT,
  CLOSE_CHAT,
  TOGGLE_CHAT,
} as const;

// --- Initial State ---
export const initialChatState: ChatState = {
  isOpen: false,
};

// --- Reducer ---
function chatReducer(state: ChatState, action: ChatAction): ChatState {
  switch (action.type) {
    case OPEN_CHAT:
      return { ...state, isOpen: true };
    case CLOSE_CHAT:
      return { ...state, isOpen: false };
    case TOGGLE_CHAT:
      return { ...state, isOpen: !state.isOpen };
    default:
      throw new Error("Unknown action: " + action.type);
  }
}

// --- Context Creation ---
export const {
  Provider: ChatProvider,
  useState: useChat,
  useDispatch: useChatDispatch,
} = makeContext<ChatState, ChatAction>({
  name: NAME,
  initialState: initialChatState,
  reducer: chatReducer,
}); 